module.exports = __webpack_public_path__ + "static/media/A7407829.f36c586f.jpg";